export default __webpack_public_path__ + "static/media/the-beers-thumb.79b62645.jpg";